/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 控制级别
 */
let EnumDeviceStatus = {
	Normal     : new EnumItem('正常', 1),
	Malfunction: new EnumItem('故障', 2),
	Offline    : new EnumItem('离线', 3),
	...enumMixn
}
export default EnumDeviceStatus
